export default __webpack_public_path__ + "static/media/BR - Linux Basics.f005d757.png";